import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '@material-ui/core';

import { AppTextField } from '@vyce/core/src/components/inputs/AppTextField';
import { PasswordField } from '@vyce/core/src/components/controlled-inputs/PasswordField';

const idRules = {
  required: 'Government Gateway ID is required',
};

const passwordRules = {
  required: 'Government Gateway password is required',
};
export const GovernmentGatewayEditBlock = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Controller
        control={control}
        rules={idRules}
        name="sender_id"
        render={({ field }) => (
          <AppTextField
            label="Government Gateway ID"
            fullWidth
            {...field}
            error={!!errors?.sender_id?.message}
            helperText={(errors?.sender_id?.message as string) || ''}
          />
        )}
      />

      <PasswordField name="password" label="Government Gateway Password" rules={passwordRules} />
    </Box>
  );
};
